import { MAILCHIMP_FLOW_PATH } from './paths'

export const MAILCHIMP_FLOW_ORIGIN_KEY = 'mpz.mailchimp.flowOrigin'

const OAUTH_RESPONSE_PATH = '/cp/company/integrations/oAuth/'

/**
 * Remember the page that opened the Mailchimp import view.
 * Stays put when already inside the view or on the OAuth return page,
 * so a later close can return to the original page.
 * @param {string} [currentPath]
 */
export function rememberMailchimpFlowOrigin(currentPath) {
    const path =
        currentPath == null ? window.location.pathname + window.location.search : currentPath
    if (path.indexOf(MAILCHIMP_FLOW_PATH) === 0) return
    if (path.indexOf(OAUTH_RESPONSE_PATH) !== -1) return
    sessionStorage.setItem(MAILCHIMP_FLOW_ORIGIN_KEY, path.split('#')[0])
}

/**
 * Read and clear the page that opened the Mailchimp import view.
 * @returns {string|null}
 */
export function consumeMailchimpFlowOrigin() {
    const path = sessionStorage.getItem(MAILCHIMP_FLOW_ORIGIN_KEY)
    sessionStorage.removeItem(MAILCHIMP_FLOW_ORIGIN_KEY)
    if (!path || path.indexOf(MAILCHIMP_FLOW_PATH) === 0) return null
    return path
}

/**
 * Open the Mailchimp import view and remember the current page.
 * @param {{ push: Function }} history
 * @param {string} path
 */
export function openMailchimpFlow(history, path) {
    rememberMailchimpFlowOrigin()
    history.push(path)
}

/**
 * Leave the Mailchimp import view for the page that opened it.
 * @param {{ replace: Function, goBack: Function, length: number }} history
 */
export function leaveMailchimpFlow(history) {
    const origin = consumeMailchimpFlowOrigin()
    if (origin) {
        history.replace(origin)
        return
    }
    if (history.length > 1) {
        history.goBack()
        return
    }
    history.replace('/cp')
}
